module.exports = __webpack_public_path__ + "img/serv_sub1_2.d7a8cac8.jpg";